import React from 'react';
import { Tag as TagIcon, X } from 'lucide-react';

interface TagListProps {
  tags: string[];
  onRemove?: (tag: string) => void;
  className?: string;
  editable?: boolean;
}

export function TagList({ tags, onRemove, className = '', editable = false }: TagListProps) {
  if (!tags || tags.length === 0) return null;

  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex items-center gap-2">
        <TagIcon className="w-4 h-4 text-blue-600" />
        <span className="font-medium text-sm text-gray-700">Tags</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <span 
            key={tag}
            className="inline-flex items-center px-2.5 py-1.5 rounded-full text-sm bg-blue-100 text-blue-800"
          >
            {tag}
            {editable && onRemove && (
              <button
                onClick={() => onRemove(tag)}
                className="ml-1.5 text-blue-600 hover:text-blue-800"
              >
                <X className="w-3 h-3" />
              </button>
            )}
          </span>
        ))}
      </div>
    </div>
  );
}